// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popupContainer {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #bb0000;
  border-radius: 8px 8px 8px 0;
  margin-left: 1rem;
  margin-bottom: 1rem;
  position: relative;
}

.popupContainer::after {
  content: "";
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 13px 13px 0 0;
  border-color: #bb0000 transparent transparent transparent;
  transform: rotate(0deg);
  position: absolute;
  bottom: -13px;
  left: -1px;
}

.popupDataContainer{
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-size: 0.75rem;
}

.popupDataContainer > div {
    display: flex;
    justify-content: space-between;
}

.popupDataContainer > div > span {
    font-weight: 500
}

.popupButton {
    color: #fff;
    width: 100%;
    min-width: 12rem;
    background-color: #770A00;
    border: none;
    padding: 0.3125rem 0.625rem;
    border-radius: 4px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/LatestRequests/components/MapOccurences/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,yDAAyD;EACzD,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".popupContainer {\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem;\n  border: 1px solid #bb0000;\n  border-radius: 8px 8px 8px 0;\n  margin-left: 1rem;\n  margin-bottom: 1rem;\n  position: relative;\n}\n\n.popupContainer::after {\n  content: \"\";\n  width: 0px;\n  height: 0px;\n  border-style: solid;\n  border-width: 13px 13px 0 0;\n  border-color: #bb0000 transparent transparent transparent;\n  transform: rotate(0deg);\n  position: absolute;\n  bottom: -13px;\n  left: -1px;\n}\n\n.popupDataContainer{\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    font-size: 0.75rem;\n}\n\n.popupDataContainer > div {\n    display: flex;\n    justify-content: space-between;\n}\n\n.popupDataContainer > div > span {\n    font-weight: 500\n}\n\n.popupButton {\n    color: #fff;\n    width: 100%;\n    min-width: 12rem;\n    background-color: #770A00;\n    border: none;\n    padding: 0.3125rem 0.625rem;\n    border-radius: 4px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
